var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"gauge-chart"}},[_c('v-chart',{attrs:{"options":_vm.graph}}),_c('div',{staticClass:"notification",on:{"click":function($event){return _vm.notify()}}},[_c('svg-icon',{attrs:{"type":"mdi","path":_vm.icons.info}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }